import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

const Feature = ({ graphic, title, subtitle, location }) => (
  <div className="w-full md:w-1/2 lg:w-1/3 px-3 pt-6">
    <a
      href={location}
      className="group block bg-gray-400 w-full h-full relative rounded-lg overflow-hidden"
    >
      <div className="transit duration-150 ease-in-out opacity-0 group-hover:opacity-100">
        <div className="absolute w-full h-full block z-10 p-6 flex items-center justify-center">
          <div className="transform transit duration-150 ease-in-out -translate-y-10 group-hover:translate-y-0 text-center z-20">
            <h3 className="text-teal-400 font-semibold text-2xl">{title}</h3>
            <h4 className="text-indigo-100 text-sm">{subtitle}</h4>
          </div>
          <div className="transit duration-150 ease-in-out bg-indigo-900 absolute w-full h-full opacity-0 group-hover:opacity-90"></div>
        </div>
      </div>
      <img className="w-full h-auto" src={graphic} />
    </a>
  </div>
)

Feature.propTypes = {
  graphic: PropTypes.string,
  location: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
}

export default Feature
